// extracted by mini-css-extract-plugin
module.exports = {"hotList":"hotList-3dZa1SAf","play_btn":"play_btn-dzbbvlY1","title":"title-aHatgQqy"};